import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip as TippyLibTooltip } from 'react-tippy'
import MaterialTooltip from 'material-ui/Tooltip'
import './styles.notmodule.css'
import attributes from '../../settings/references.json'

const Tooltip = (props) => {
    // We have no content
    if (!attributes.feature.tooltipsEnabled || props.content == null || props.content === '') {
        // We have no children, just return null
        if (props.children == null) return null

        // We have an array of children, return them wrapped in a div
        // todo: when we have upgraded to react 16, we can skip this part and
        //       just return the array directly
        if (Array.isArray(props.children)) return <div>{props.children}</div>

        // We have a single element, we can just return it
        return props.children
    }

    if (attributes.feature.tooltipProvider === 'mui') {
        return <MaterialUiTooltip {...props} />
    }

    return <TippyTooltip {...props} />
}

Tooltip.propTypes = {
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']), // eslint-disable-line
    style: PropTypes.object, // eslint-disable-line
    className: PropTypes.string, // eslint-disable-line
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]),
    type: PropTypes.oneOf(['bug', 'feedback']), // eslint-disable-line
    noAnimation: PropTypes.bool, // eslint-disable-line
}

Tooltip.defaultProps = {
    position: 'top',
}

const MaterialUiTooltip = (props) => {
    const options = {
        placement: props.position,
        title: props.content,
        style: props.style,
    }

    const classes = []
    if (props.type != null) {
        if (props.type === 'bug') classes.push('bugTooltip')
        if (props.type === 'feedback') classes.push('feedbackTooltip')
    }
    if (props.noAnimation) {
        classes.push('noAnimationTooltip')
    }
    if (props.className != null && props.className !== '') {
        classes.push(props.className)
    }

    if (classes.length > 0) {
        options.className = classes.join(' ')
    }

    return <MaterialTooltip {...options}>{props.children}</MaterialTooltip>
}

MaterialUiTooltip.propTypes = {
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
    style: PropTypes.object, // eslint-disable-line
    className: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]),
    type: PropTypes.oneOf(['bug', 'feedback']),
    noAnimation: PropTypes.bool,
}

const TippyTooltip = (props) => {
    // note that trigger has 64 possible values since it accepts any
    // number of the allowed inputs in any order seperated by space

    const options = {
        position: props.position,
        style: props.style,
    }

    if (typeof props.content === 'string') {
        options.title = props.content
    } else {
        options.html = props.content
    }

    if (props.type != null) {
        if (props.type === 'bug') options.position = 'left'
        if (props.type === 'feedback') options.position = 'left'
    }

    if (props.noAnimation) {
        options.animation = 'none'
    }

    return <TippyLibTooltip {...options}>{props.children}</TippyLibTooltip>
}

TippyTooltip.propTypes = {
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
    style: PropTypes.object, // eslint-disable-line
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]),
    type: PropTypes.oneOf(['bug', 'feedback']),
    noAnimation: PropTypes.bool,
}

export default Tooltip



// WEBPACK FOOTER //
// ./src/components/Tooltip/index.js